export const { getColor } = window as unknown as { getColor: (s: string) => string };
